import { render, staticRenderFns } from "./AddTemplate.vue?vue&type=template&id=d638bb70&scoped=true&"
import script from "./AddTemplate.vue?vue&type=script&lang=js&"
export * from "./AddTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplate.vue?vue&type=style&index=0&id=d638bb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d638bb70",
  null
  
)

export default component.exports